import { render, staticRenderFns } from "./AiPrompts.vue?vue&type=template&id=8c3903b6&scoped=true"
import script from "./AiPrompts.vue?vue&type=script&setup=true&lang=js"
export * from "./AiPrompts.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3903b6",
  null
  
)

export default component.exports